var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 41,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M34.836 16.514l7.241-4.159L21.476.588.872 12.355l7.241 4.159-7.241 4.134 7.241 4.162-7.241 4.134L21.476 40.78l20.601-11.836-7.241-4.134 7.241-4.162-7.241-4.134zM21.476 2.32l17.572 10.039-17.572 10.096L3.901 12.359 21.476 2.32zM9.627 17.384l11.849 6.808 11.847-6.808 5.725 3.27L21.476 30.75 3.901 20.654l5.726-3.27zm29.421 11.564L21.476 39.044 3.901 28.948l5.726-3.269 11.849 6.806 11.847-6.806 5.725 3.269z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayers);
export default __webpack_public_path__ + "static/media/layers.481e859853418c67168ba498b6af621f.svg";
export { ForwardRef as ReactComponent };